import React, { useState, useEffect } from 'react';
import moment from 'moment';
import useStyles from './styles';
import Form from 'global/components/form';
import { get, set, uniqBy, last } from 'global/lib/lodash';
import { Paper, Button, Icon, LinearProgress, IconButton, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import sendData from 'redux/actions/sendData';
import { useScreen } from 'global/styles';
import useRetrieveData from 'global/hooks/useRetrieveData';
import clsx from 'clsx';
import DropRealms from 'global/components/droprealms';
import { wait, getUserAppPermissions, reverseUserAppPermissions } from 'global/utils';
import { findServerPerm, flattenAllRealms } from 'global/utils';
import { UserPermission } from 'global/lib/filter';
import { userHasPermissions } from 'redux/actions/userLogin';
import { VendorList } from '../../admin/vendors';
import { useClients } from 'global/hooks/useVendors';
import useNavSettings from 'global/hooks/useNavSettings';
import { useLocation } from 'react-router-dom';
import { getUserPermissions } from 'redux/actions/userLogin';
import { useUser } from 'global/hooks/useUser';
import { keyBy } from '../../../global/lib/lodash';

const MODDATEFORMAT = 'l h:mma';

export default (props) => {
  const [canEdit, setCanEdit] = useState(false);
  const [allowedToEdit, setAllowedToEdit] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [hideForm, setHideForm] = useState(false);
  const [formState, setFormState] = useState({});
  // const [allRealms, setAllRealms] = useState([]);
  const [error, setError] = useState();
  const { me } = useUser();
  const { isMobileXS } = useScreen();
  const classes = useStyles({ isMobile: isMobileXS });
  const [user, setUser] = useState(props.user || me);
  const [ac, setAc] = useState({});
  const [ug, setUserGroups] = useState({});
  const [userRealmId, setUserRealmId] = useState(get(user, 'realm.id'));
  const [usersRealms, setUsersRealms] = useState([]);
  // const [myRealms, setMyRealms] = useState([]);
  const { filterPermissionsByNav } = useNavSettings();
  const dispatch = useDispatch();

  const userId = get(user, 'id');
  const userIsMe = get(me, 'id') == userId;
  const meRealm = get(me, 'realm.id');

  const permData = useRetrieveData({ url: `/permissions` }, { build: ['permissions'] });
  const activity = useRetrieveData({ url: `/activities` }, { build: ['activities'], params: { filter: { causer_id: get(user, 'id'), log_name: 'user_login' } }, transformData: (d) => last(d) });
  const usergroups = useRetrieveData({ url: `/user-groups` }, { build: ['userGroups'] });
  const meRealms = useRetrieveData(
    { url: `/users/${get(me, 'id')}` },
    {
      useEffect: true,
      params: {
        include: 'realm,realms,permissions',
        filter: {
          user_realm_id: meRealm,
          includes: {
            realms: { realm_id: meRealm },
          },
        },
      },
      build: ['users'],
      transformData: (d) => get(d, '0'),
    }
  );
  const { data, loading, update } = useRetrieveData(
    { url: `/users/${get(user, 'id')}` },
    {
      useEffect: true,
      params: {
        include: 'realm,realms,permissions,userGroups',
        filter: {
          user_realm_id: meRealm,
          includes: {
            realms: { realm_id: meRealm },
          },
        },
      },
      build: ['users'],
      transformData: (d) => get(d, '0'),
    }
  );
  const ate = useRetrieveData({ url: `/users/${userId}/can-manage-realms` }, { build: ['users'] });
  useEffect(() => {
    setAllowedToEdit(userIsMe ? true : !!ate.data);
  }, [ate.data]);

  const vendors = useClients(userRealmId, userId);

  const loc = useLocation();
  useEffect(() => {
    const { isModal } = props;
    const isPath = loc.pathname.indexOf('users/manage') > -1;
    const hasSearch = loc.search;
    if (isPath && isModal && !hasSearch && props.onClose) {
      //user hit the back button
      props.onClose();
    }
  }, [loc]);

  useEffect(() => {
    if (data && data.id) {
      setUser({
        ...data,
        status: data.status === 0 ? 'deactivated' : 'active',
      });
      setUserRealmId(get(data, 'realm.id'));
      const _usersRealms = flattenAllRealms(get(data, 'realms', []));
      setUsersRealms(_usersRealms);
      const userPerms = getUserAppPermissions(data.permissions);
      const access = {};
      (userPerms || []).map((up) => set(access, up.value, true));
      setAc(access);

      const groups = {};
      usergroups.data.map(u => {
        groups[u.id] = !!data.userGroups.find(uu => uu.id == u.id)
      })
      setUserGroups(groups);
    }
  }, [data, usergroups.data, meRealms.data]);

  const toggleEdit = () => {
    setCanEdit(!canEdit);
  };

  const formatData = async () => {
    const p = reverseUserAppPermissions(formState.access);

    const setPerms = p.map((ac) => ({ ...findServerPerm(permData.data, `${ac.match}.${get(user, 'realm.id')}`) }));
    const notAppPerms = (data.permissons || []).filter((sp) => UserPermission.find((up) => sp.name.indexOf(up.match)) === -1);
    const _perms = uniqBy([...notAppPerms, ...setPerms], 'id');

    const relationships = {};

    set(relationships, 'permissions', {
      data: _perms.filter((p) => p.id).map((ac) => ({ type: 'permissions', id: ac.id.toString() })),
    });

    const userGroups = [];
    usergroups.data.map(u => {
      if (get(formState, `userGroups.${u.id}`)) {
        userGroups.push({ type: 'user-groups', id: `${u.id}` })
      }
    })
    set(relationships, 'userGroups', { data: userGroups })

    const attributes = {
      name: get(formState, 'name'),
      archived: get(formState, 'status') === 'deactivated' ? true : false,
    };

    return {
      data: {
        type: 'users',
        id: get(user, 'id', '').toString(),
        attributes,
        relationships,
      },
    };
  };

  const formSubmit = async () => {
    try {
      setFormLoading(true);
      setError();
      const d = await formatData();
      await sendData(
        {
          url: `/users/${user.id}`,
          method: 'patch',
          data: d,
        },
        { simulate: false }
      );
      await update();
      setFormState({});
      setFormLoading(false);
      setCanEdit(false);
    } catch (err) {
      setFormLoading(false);
      setError(`${err.message}. Please try again.`);
    } finally {
      dispatch(getUserPermissions());
    }
  };

  const onFormState = (vals) => {
    setFormState({ ...formState, ...vals });
  };

  const reset = async () => {
    setHideForm(true);
    setFormState({});
    await wait(200);
    setHideForm(false);
  };

  useEffect(() => {
    if (!canEdit) {
      reset();
    }
  }, [canEdit]);

  const onUpdateAccess = (realms) => {
    const fs = { ...formState };
    const realmAccess = Object.keys(realms).map((k) => realms[k]);
    set(fs, 'realmCompanyAccess', realmAccess);
    setFormState(fs);
  };

  const realmCompanyAccess = get(formState, 'realmCompanyAccess', usersRealms);

  return !data || activity.loading || loading || hideForm ? (
    <LinearProgress />
  ) : (
    <div className={classes.container}>
      {error && (
        <Alert
          severity="error"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setError();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {error}
        </Alert>
      )}

      <div className={classes.buttonContainer}>
        <div style={{ marginBottom: 20 }}>
          <Typography variant={'h4'}>{get(user, 'name')}</Typography>
        </div>

        {!formLoading && allowedToEdit && (
          <Button disabled={!userIsMe && !userHasPermissions(['manageUsers'])} color={'secondary'} variant="contained" onClick={toggleEdit} startIcon={<Icon>{canEdit ? 'close' : 'edit'}</Icon>}>
            {'Edit'}
          </Button>
        )}
      </div>

      <Form
        loading={formLoading}
        showAllScreens={true}
        formStyle={classes.formStyle}
        onSubmit={formSubmit}
        canSubmit={canEdit}
        onFormState={onFormState}
        submitText="Save Changes"
        screens={[
          [
            {
              title: 'GENERAL INFO',
              titleStyle: classes.titleStyle,
              screenContainerStyle: isMobileXS ? classes.screenContainerMobile : classes.screenContainer,
              screenContainer: {
                props: {
                  className: classes.screenWidth,
                },
              },
              inputs: [
                {
                  id: 'name',
                  type: 'TextField',
                  defaultValue: () => get(data, 'name', ''),
                  props: {
                    label: 'Name',
                    disabled: !canEdit,
                  },
                },
                {
                  id: 'email',
                  type: 'TextField',
                  defaultValue: () => get(data, 'email', ''),
                  props: {
                    label: 'Email',
                    disabled: true,
                  },
                },
                {
                  id: 'status',
                  type: 'RadioButton',
                  defaultValue: () => user.status,
                  options: [
                    { value: 'active', label: 'Active' },
                    { value: 'deactivated', label: 'Deactivated' },
                  ],
                  props: {
                    label: 'Status',
                    disabled: !canEdit || !userHasPermissions(['manageUsers']),
                    className: classes.flexRow,
                  },
                },
                {
                  id: 'createdAt',
                  type: 'TextField',
                  defaultValue: () => `${moment(get(data, 'createdAt')).format(MODDATEFORMAT)}`,
                  props: {
                    label: 'Created',
                    disabled: true,
                  },
                },
                {
                  id: 'lastLogin',
                  type: 'TextField',
                  defaultValue: () => (get(activity.data, 'createdAt') ? `${moment(get(activity.data, 'createdAt')).format(MODDATEFORMAT)}` : 'N/A'),
                  props: {
                    label: 'Last Login',
                    disabled: true,
                  },
                },
              ]
            },
          ],
          [
            {
              title: 'COMPANY ACCESS',
              titleStyle: classes.titleStyle,
              screenContainerStyle: isMobileXS ? classes.screenContainerMobile : classes.screenContainer,
              screenContainer: {
                component: Paper,
                props: {
                  elevation: 5,
                  className: clsx(classes.accessContainer),
                },
              },
              inputs: [
                {
                  id: 'userGroups',
                  type: 'Checkbox',
                  defaultValue: () => ug,
                  options: usergroups.data.map(u => ({ ...u, value: u.id, label: u.name })),
                  props: {
                    label: 'User Groups',
                    disabled: !canEdit,
                  },
                },
                {
                  id: 'access',
                  type: 'Checkbox',
                  defaultValue: () => ac,
                  options: filterPermissionsByNav().map((up) => ({ ...up, label: up.title })),
                  props: {
                    label: 'Permissions',
                    disabled: !canEdit || !userHasPermissions(['manageUsers']),
                  },
                },
                {
                  component: <DropRealms canAdd showModify={false} onUpdate={onUpdateAccess} realms={realmCompanyAccess} />,
                },
              ],
            },
            {
              title: 'CLIENT ACCESS',
              titleStyle: classes.titleStyle,
              screenContainerStyle: isMobileXS ? classes.screenContainerMobile : classes.screenContainer,
              screenContainer: {
                component: Paper,
                props: {
                  elevation: 5,
                  className: clsx(classes.accessContainer),
                },
              },
              inputs: [{ component: <VendorList {...vendors} hideBorders canEdit={false} /> }],
            },
          ],
        ]}
      />
    </div>
  );
};
